import { Button, Card, Col, Input, Row } from 'antd';
import { useState } from 'react';
import { BaseApi } from '../base.api';
import { useNavigate } from 'react-router-dom';
import TextArea from 'antd/es/input/TextArea';

 const AddSource=()=> {
  const navigate = useNavigate()
  const [isNewSource,setIsNewSource] = useState({name:""})

  const changeSourceValue=(e:any)=>{
    setIsNewSource({
      name:e
    })
  }
  const handleNewSource=async()=>{
    console.log(isNewSource);
    await new BaseApi().postData("/common-service/v1/tags/source-tag/admin",isNewSource)
    navigate('/main/sources')
  }
  return (
    <>
      <Button><a href='/main/sources'>Back</a></Button>
      <div style={{display:"flex",justifyContent:"center"}}>
        <Card
          style={{ width: 500, marginBottom: 80, marginTop: 80 }}
          title="Create New Source Tag"
        >
          <form onSubmit={handleNewSource}>
            <Row gutter={16}>
              <Col span={24}>
                <div>
                  <label>Name: </label>
                  <Input
                    type="text"
                    value={isNewSource.name}
                    onChange={(e)=>changeSourceValue(e.target.value)}
                    placeholder="Enter tag name"
                    required
                  />
                </div>
              </Col>
              
            </Row>
            <Row justify="center" style={{ marginTop: 16 }}>
              <Col>
                <Button type="primary" onClick={handleNewSource}>
                  Create
                </Button>
              </Col>
            </Row>
          </form>
        </Card>
        
      </div>

    </>
  )
}
export default AddSource